"use client"
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { NextPage } from 'next';
import family1 from "../../../public/family1.png";
import Navbar2 from '../navbar2';
import Navbar3 from '../navbar3'
//import { ShoppingCart } from "iconsax-react";
import AppHeaderPhoto from "../../../public/AppHeader.png";
import Map from '@/lib/seatmap/seatmap';
import { Roboto, Inter } from 'next/font/google';
const inter = Inter({ subsets: ['latin'] })
const roboto = Roboto({ weight: ['300'], subsets: ['latin'] });
import { useDispatch } from 'react-redux';
import { AppDispatch, useAppSelector } from '@/redux/store';
import Footer from '@/components/footer/page';
require('dotenv').config({ path: '../.env' });
import axios from 'axios';
import Navbar from '../navbar';
import { FaFacebook } from 'react-icons/fa'
import Loader from '../LoaderFile/Loader';
import moment from 'moment';
import BottomFooter from '@/components/BottomFooter/BottomFooter';
import { GoArrowLeft } from "react-icons/go";
import { Fredoka } from "next/font/google";
const fredoka = Fredoka({ subsets: ["latin"] });
interface TicketGroup {

  format: string;
  retail_price: number;
  id: number;
  url: string;
  type: string;
  row: string; // Change the type of 'row' property to string
  section: string;
  quantity: number;
  available_quantity: number;
  wholesale_price: number;
  eticket: boolean;
  instant_delivery: boolean;
  intended_for_instant_delivery: boolean;
  tevo_section_name: string;
  splits: number[];
  wheelchair: boolean;
  public_notes: string;
}


interface Viewtickets {
  available_count: number;

  configuration: {
    id: string;
  };
  id: number;
  long_term_popularity_score: number;
  name: string;
  occurs_at: string;
  venue: {
    id: string;
    slug: string;
    url: string;
    slug_url: string;
    name: string;
    location: string;
    time_zone: string;
  };

}
interface ViewticketsProps {
  viewtickets: Viewtickets;
  ticketGroup: TicketGroup[];
}
function formatDate(inputDate: any) {
  const date = new Date(inputDate);

  const day = date.getUTCDate();
  const month = date.toLocaleDateString('en-US', { month: 'long', timeZone: 'UTC' });

  const formattedDate = `${month} ${day}`;
  return formattedDate;
}


function formatDay(inputDate: any): string {
  const date = new Date(inputDate);

  const dayName = date.toLocaleString('en-US', { weekday: 'long', timeZone: 'UTC' });

  return dayName;
}



function formatTime(inputDate: any): string {
  // Parse the input date using Moment.js
  const momentDate = moment.parseZone(inputDate);

  // Format the time in UTC using Moment.js in the desired format
  const formattedTime = momentDate.utc().format('hh:mm A');

  return formattedTime;
}
function formatYear(inputDate: any): string {
  const date = new Date(inputDate);
  const year = date.getFullYear();
  return String(year);
}

function formatDayApp(inputDate: any): string {
  const date = new Date(inputDate);
  const dayName = date.toLocaleString('en-US', { weekday: 'short', timeZone: 'UTC' }); // Returns abbreviated day name (e.g., "Wed")
  return dayName;
}

function formatDateApp(inputDate: any): string {
  const date = new Date(inputDate);
  const day = date.getUTCDate();
  const month = date.toLocaleDateString('en-US', { month: 'short', timeZone: 'UTC' }); // Abbreviated month (e.g., "Dec")

  const formattedDate = `${day} ${month}`; // Combines day and month (e.g., "21 Dec")
  return formattedDate;
}



const Viewtickets: NextPage<ViewticketsProps> = ({ viewtickets, ticketGroup }) => {
  const router = useRouter();
  const [cartItems, setCartItems] = React.useState(0)
  const dispatch = useDispatch<AppDispatch>();
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const cartArray = useAppSelector((state) => state.cartReducer);
  const [loading, setLoading] = useState(false);
  React.useEffect(() => {
    setCartItems(cartArray.ticketGroup.length)
    console.log(cartArray.ticketGroup.length)
  }, [cartArray])
  // const data =  getData(viewtickets.id);
  // console.log(ticketGroup);
  // console.log("datta" , data)
  // console.log('viewtickets:', viewtickets);

  // Check if viewtickets object is defined
  // if (viewtickets) {
  //     // Access properties of the viewtickets object
  //     console.log(viewtickets.available_count);
  //     console.log(viewtickets.configuration.id);
  //     console.log(viewtickets.venue.id)
  //     // Access other properties as needed
  // } else {
  //     console.log('No viewtickets found');
  // }




  const handleBackClick = () => {
    router.back();
  };

  const isPWA = useAppSelector((state: any) => state.pwacheckReducer.isPWA);

  return (
    loading ? <Loader /> :
      <div className=''>
        {/* <Navbar2 /> */}
        {/* comented out the above 1 line and added below 15 line for solving  task 1139 */}
        {!isPWA && (
          <div className='w-full'>
            <div className='bg-[#201F5C] gap-2 py-2 w-full flex  md:flex-row flex-col items-center justify-center'>
              <h1 className='font-normal text-[1rem]  max-[368px]:text-[0.7rem] text-white'>Price may be higher or lower than face value.</h1>
              <a
                href="https://www.facebook.com/groups/KarmaTickets"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1 text-[1rem] max-[368px]:text-[0.7rem] text-orange-500"
              >
                Connect with us on Facebook
                <FaFacebook className="text-orange-500" />
              </a>
            </div>
            <Navbar3 className={`bg-[#3BC3F2] w-full py-4`} setLoading={setLoading} />
          </div>
        )}


        {!isPWA ? (
          <div className={`md:hidden flex items-center justify-center w-full px-4 sm:px-8 py-4 gap-4 ${roboto.className}`}>
            <div className={`${inter.className} bg-[#EBF2FD] rounded-lg flex flex-col items-center justify-center py-4 px-2`}>
              <h1 className='text-base text-center font-bold'>{viewtickets?.name}</h1>
              <h1 className='text-base text-center text-[#989797] font-normal'>{viewtickets?.venue?.name} - {viewtickets?.venue?.location}</h1>
              <h1 className='text-[#397BEA] text-center text-base font-normal'>{formatDay(viewtickets?.occurs_at)} {formatDate(viewtickets?.occurs_at)}, {formatYear(viewtickets?.occurs_at)} {formatTime(viewtickets?.occurs_at)}</h1>
            </div>
          </div>
        ) : (
          <>
            <div className='header-container'>
              <style jsx>{`
                        .header-container {
                        background-image: linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${AppHeaderPhoto.src});
                        background-size: cover;
                        background-position: center;
                        height: calc(8vh + env(safe-area-inset-top));
      padding-top: env(safe-area-inset-top);
                        }
                    `}</style>
              <div className='flex justify-between items-center mx-6'>
                <div className='mt-2'>
                  <Image src="/Logo.png" alt="logo" width={73.27} height={38} />
                </div>
                {/* <div className="bg-white rounded-full flex justify-center items-center w-10 h-10 mt-3">
                  <ShoppingCart size="26" color="#FF801F" variant="Bulk" />
                </div> */}
              </div>
            </div>
            <div className='flex gap-2 mx-2 mb-4 mt-[10px]'>

              <div>
                <button onClick={handleBackClick}>
                  <GoArrowLeft className="text-black text-center h-8 w-8" />
                </button>
              </div>
              <div>
                <div className={`font-semibold text-xl`}>{viewtickets?.name}</div>
                <div className="text-lg font-medium">
                  <span className="text-[#011E7B]">{formatDateApp(viewtickets?.occurs_at)}</span>
                  <span className="text-[#8A98C2] ml-2">
                    {formatDayApp(viewtickets?.occurs_at)}, {formatTime(viewtickets?.occurs_at)}
                  </span>
                </div>
                <div className={`font-medium text-base`}>{viewtickets?.venue?.name} &#124; {viewtickets?.venue?.location}</div>
              </div>
            </div>
          </>
        )}


        <Map venueId={viewtickets.venue?.id} configurationId={viewtickets.configuration?.id} ticketGroups={ticketGroup as TicketGroup[]} available_count={viewtickets?.available_count} eventId={viewtickets?.id} viewtickets={viewtickets} />


        <div className=''>
          <BottomFooter />
        </div>
      </div>
  )
}

export default Viewtickets
